module.exports = __webpack_public_path__ + "img/ligia.ca62623e.jpg";